import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const saveAppointmentApi = async (params) => {
    const response = await axios({
    url: `${config.api.base_url}book-appointment`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default saveAppointmentApi;
